// IE Hub - Count Label Field Component
// Display label with count in a circular badge

import React, { forwardRef } from 'react';
import {
  Box,
  Typography,
  styled
} from '@mui/material';

interface CountLabelProps {
  label?: string | React.ReactNode;
  value?: number;
  sx?: Record<string, unknown>;
  [key: string]: any;
}

// Styled count container
const CountContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  gap: theme.spacing(2),
}));

// Styled count badge
const CountBadge = styled(Box)(({ theme }) => ({
  width: 40,
  height: 40,
  borderRadius: '50%',
  border: `2px solid ${theme.palette.primary.main}`,
  backgroundColor: theme.palette.grey[100],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
}));

// Styled count text
const CountText = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '1rem',
  color: theme.palette.primary.main,
}));

const CountLabelField = forwardRef<HTMLDivElement, CountLabelProps>(
  ({
    label,
    value = 0,
    sx = {},
    ...otherProps
  }, ref) => {
    return (
      <CountContainer ref={ref} sx={{ width: '100%', ...sx }} {...otherProps}>
        {label && (
          <Typography data-testid="ui-fields-count-label-field-text-action"
            variant="body1"
            sx={{
              fontWeight: 500,
              color: 'text.primary',
              flex: 1,
            }}
          >
            {label}
          </Typography>
        )}
        
        <CountBadge>
          <CountText variant="body1">
            {value}
          </CountText>
        </CountBadge>
      </CountContainer>
    );
  }
);

CountLabelField.displayName = 'CountLabelField';

export default CountLabelField;
